import React from 'react';
import Loader from 'react-loaders';
import './NewLoader.sass';

const NewLoader = ({ isFullScreen }) => (
  <Loader
    type="ball-scale-ripple-multiple"
    className={isFullScreen && 'fs'}
  />
);

export default NewLoader;